package com.anjuros.website.redesign.sections.about

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.jsonString
import com.anjuros.website.redesign.components.rdBreadcrumbJsonLd
import com.anjuros.website.redesign.util.RdExternal
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.anjuros.website.redesign.util.SITE_URL

/** JSON-LD for the About page: the founder as a Person linked to the business, plus the breadcrumb. */
@Composable
fun aboutStructuredData(): String {
    val name = LocalText(RdText.ABOUT_NAME)
    val breadcrumb = rdBreadcrumbJsonLd(RdText.ABOUT_CRUMB, RdRoute.ABOUT)
    return """
        {"@context":"https://schema.org","@graph":[
         {"@type":"AboutPage","url":"$SITE_URL${RdRoute.ABOUT}","name":"About Anjuros Development",
          "mainEntity":{"@id":"$SITE_URL/#business"}},
         {"@type":"ProfessionalService","@id":"$SITE_URL/#business","name":"Anjuros Development",
          "legalName":"Anjuros Development Limited","url":"$SITE_URL/","founder":{"@id":"$SITE_URL${RdRoute.ABOUT}#founder"}},
         {"@type":"Person","@id":"$SITE_URL${RdRoute.ABOUT}#founder","name":${jsonString(name)},"jobTitle":"Founder and developer",
          "worksFor":{"@id":"$SITE_URL/#business"},"sameAs":["${RdExternal.LINKEDIN}","${RdExternal.DEVELOPER_PORTFOLIO}"],
          "knowsAbout":["Website design","Android development","Software development","Local SEO"]},
         $breadcrumb
        ]}
    """.trimIndent()
}
